<template>
  <v-layout column>
    <v-alert v-model="sent" type="success" dismissible>
      Email sent!
    </v-alert>
    <v-btn @click="sendEmail">
      Send email
    </v-btn>
  </v-layout>
</template>

<script>
import { auth } from '@/plugins/firebase';

export default {
  name: 'AdminVerify',
  data: () => ({
    sent: false,
  }),
  methods: {
    async sendEmail() {
      await auth.currentUser.sendEmailVerification();
      this.sent = true;
    },
  },
};
</script>

<style></style>
